var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M7.49997 12C7.49997 11.3369 7.64788 10.7071 7.91075 10.1372C8.11425 9.69593 8.07923 9.15924 7.73563 8.81564L5.15856 6.23857C4.7485 5.82851 4.07238 5.85004 3.74139 6.32622C2.62095 7.93817 1.96997 9.89396 1.96997 12C1.96997 14.1044 2.61994 16.0587 3.73274 17.67C4.06275 18.1478 4.7399 18.1709 5.15104 17.7608L7.73411 15.1843C8.07848 14.8408 8.1139 14.3035 7.91029 13.8618C7.64771 13.2921 7.49997 12.6627 7.49997 12Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M12 7.5C12.6631 7.5 13.2929 7.64791 13.8628 7.91078C14.3041 8.11428 14.8408 8.07926 15.1844 7.73566L17.7336 5.18643C18.1429 4.77717 18.1224 4.10256 17.6477 3.77141C16.0416 2.65097 14.0845 2 11.97 2C9.86583 2 7.91874 2.64985 6.3098 3.76248C5.83218 4.09277 5.80906 4.76993 6.21916 5.18107L8.78023 7.74868C9.12613 8.09546 9.66809 8.12873 10.1117 7.92105C10.6855 7.6524 11.3237 7.5 12 7.5Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M19.8901 5.90608C19.7124 5.67646 19.3751 5.66451 19.1695 5.86955L15.9507 9.08009C15.7773 9.25304 15.7574 9.52474 15.8813 9.73598C16.2717 10.4014 16.5 11.1722 16.5 12C16.5 12.828 16.2716 13.5989 15.881 14.2645C15.7572 14.4755 15.7769 14.7469 15.9499 14.9199L19.1695 18.1395C19.375 18.3449 19.7127 18.3332 19.8905 18.1033C21.1957 16.415 21.97 14.2968 21.97 12C21.97 9.70296 21.1956 7.59315 19.8901 5.90608Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M12 16.4999C11.172 16.4999 10.4011 16.2715 9.73552 15.8809C9.52451 15.7571 9.25312 15.7768 9.08012 15.9498L5.83055 19.1994C5.62506 19.4049 5.63681 19.7426 5.86671 19.9204C7.55503 21.2256 9.67318 21.9999 11.97 21.9999C14.2771 21.9999 16.3969 21.2249 18.0778 19.9107C18.3058 19.7324 18.3164 19.3963 18.1118 19.1917L14.8872 15.9671C14.7154 15.7953 14.4463 15.7745 14.2359 15.8959C13.5728 16.2785 12.8114 16.4999 12 16.4999Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }